import { adminUsers } from '../actionTypes';

const initialState = {
  users: [],
  loading: false,
  error: null,
};

export default function adminUsersReducer(state = initialState, action) {
  switch (action.type) {
    case adminUsers.get.start:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case adminUsers.get.end:
      return {
        ...state,
        loading: false,
        users: action.payload || [],
        error: null,
      };

    case adminUsers.get.error:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
